import React from "react";
import logo from "../../../assets/images/inc-logo.png";
import "../../../assets/css/style.css";
import LicesneOrga from "../../../assets/images/licenseOrganization.png";
import LicenseUser from "../../../assets/images/licesnseUser.png";
import LicenseSucess from "../../../assets/images/licenseSucess.png";
import LicenseLogin from "../../../assets/images/licenseLogin.png";
import SubUser from "../../../assets/images/subUser.png";
import SubUser2 from "../../../assets/images/subUser2.png";
import SubUser3 from "../../../assets/images/subUser3.png";
import SubUser4 from "../../../assets/images/subUser4.png";
import SubUser5 from "../../../assets/images/subUser5.png";
import SubUser6 from "../../../assets/images/subUser6.png";
import SubUser7 from "../../../assets/images/subUser7.png";

const UserDetails = () => {
  return (
    <>
      <div className="headerpolicy">
        <div className="container">
          <img src={logo} alt="INC Logo" />
        </div>
      </div>

      <div className="main-wrapper">
        <div className="container">
          <div className="inc-card-title">
            <h3>Device Onboarding</h3>
          </div>
          <br />
          <p style={{ paddingLeft: "2em" }}>
            <strong>Step 1: Login:</strong>
            <br />
            Login using your own admin credentials created during the onboarding
            process.
          </p>
          <br />
          <img
            src={SubUser}
            className="helpLicesne-img"
            alt="Customer Overview"
          />
          <br />
          <p style={{ paddingLeft: "2em" }}>
            <strong>Step 2: Go to Device Management :</strong> <br />
            Navigate to the Device Management section from the left sidebar, as
            shown in the image below
          </p>
          <p style={{ paddingLeft: "2em" }}>
            <strong>Step 3: Click on "Device" :</strong>
            <br />
            Within the Device Management section, click on the "Device" tab to
            view or manage devices.
          </p>
          <br />
          <img
            src={SubUser3}
            className="helpLicesne-img"
            alt="Customer Overview"
          />
          <br />
          <p style={{ paddingLeft: "2em" }}>
            <strong>Step 4: Add a New Device :</strong>
            <br />
            Click the "Add Device" button located at the top-right corner of the
            device list panel.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            <strong>Step 5: Choose Device Type:</strong>
          </p>
          <br />
          <p style={{ paddingLeft: "2em" }}>
            ⚠️ If you purchased the solution from the GCP Marketplace, be sure
            to select HTTPS as the device type/protocol.
          </p>
          <br />
          <img
            src={SubUser5}
            className="helpLicesne-img"
            alt="Customer Overview"
          />
          <p style={{ paddingLeft: "2em" }}>
            <strong>Step 6: Enter Device Details</strong>
            <br />
            Fill in the required Device Simulator details such as:
          </p>

          <ul>
            <li>Serial Number</li>
            <li>MAC Address</li>
            <li>Model</li>
          </ul>
          <p style={{ paddingLeft: "2em" }}>
            You can refer to the Device Simulator Configuration for valid test
            values.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            <strong>Step 7: Submit:</strong>
            <br />
            Click "Add Device" to complete the process.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            ✅ Your device will now appear in the list and is ready for use in
            simulations and testing.
          </p>
          <br />
          <br />
        </div>

        <footer>
          <div className="container">
            Powered by{" "}
            <a
              href="https://www.vvdntech.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              VVDN Technologies
            </a>
          </div>
        </footer>
      </div>
    </>
  );
};

export default UserDetails;
